const idValido = /^ID(001|002|003|011|012|013)\d{31}$/;
const reciboValido = /^\d\.\d\.\d{19}$/;
const lista = (v) => [
  ...new Set(
    String(v || "")
      .split(/[\n,;]/)
      .map((s) => s.trim())
      .filter(Boolean)
  )
];
export function validarRecuperacao(base, ids, recibos, mapa) {
  const id = lista(ids),
    nrRec = lista(recibos);
  const nrInsc = String(base.nrInsc || "").replace(/\D/g, "");
  if (![1, 2].includes(Number(base.tpInsc)) || !/^\d{8,15}$/.test(nrInsc))
    throw new Error("Informe o tipo e a inscrição do empregador corretamente.");
  if (!id.length && !nrRec.length)
    throw new Error(
      "Informe ao menos um ID de totalizador ou recibo próprio do totalizador."
    );
  if (id.length > 500 || nrRec.length > 500)
    throw new Error("Informe no máximo 500 IDs e 500 recibos por solicitação.");
  if (id.some((v) => !idValido.test(v)))
    throw new Error(
      "Há um ID inválido. Use o identificador completo do totalizador (ID seguido de 34 dígitos)."
    );
  if (nrRec.some((v) => !reciboValido.test(v)))
    throw new Error(
      "Há um recibo inválido. Formato esperado: 1.2. seguido de 19 dígitos."
    );
  const nrRecTotalizadorPorId = {};
  lista(mapa).forEach((line) => {
    const parts = line.split("=").map((v) => v.trim());
    if (
      parts.length !== 2 ||
      !idValido.test(parts[0]) ||
      !reciboValido.test(parts[1]) ||
      !id.includes(parts[0])
    )
      throw new Error(
        "Mapa inválido. Use ID=RECIBO, com um ID presente na lista de totalizadores."
      );
    if (
      nrRecTotalizadorPorId[parts[0]] &&
      nrRecTotalizadorPorId[parts[0]] !== parts[1]
    )
      throw new Error("Um mesmo ID possui recibos diferentes no mapa.");
    nrRecTotalizadorPorId[parts[0]] = parts[1];
  });
  return {
    tpInsc: Number(base.tpInsc),
    nrInsc,
    id,
    nrRec,
    ...(Object.keys(nrRecTotalizadorPorId).length
      ? { nrRecTotalizadorPorId }
      : {})
  };
}
